// extracted by mini-css-extract-plugin
export var width100 = "F_bD g_bD";
export var design3Pos = "F_vH g_b6";